import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useRef, useState } from 'react';
import { useTheme } from 'styled-components';
import { useClickOutside } from '../../hooks';
import { Spacing } from '../../theme';
import { Dropdown } from '../Dropdown';
import { Icon } from '../Icon';
import { Text } from '../Text';
import { StyledContainer, StyledIconWrapper, StyledLabel, StyledLabelContainer, } from './Select.style';
export function Select({ id, label, options, onChange }) {
    const selectedOption = options.find((option) => option.isSelected === true) || options[0];
    const [selected, setSelected] = useState(selectedOption);
    const [isOpened, setIsOpened] = useState(false);
    const [dimensions, setDimensions] = useState({ top: 0, left: 0, width: 0 });
    const labelRef = useRef(null);
    const handleClickOutside = () => setIsOpened(false);
    const containerRef = useClickOutside(handleClickOutside);
    const theme = useTheme();
    useEffect(() => {
        setSelected(selectedOption);
    }, [selectedOption]);
    const toggleVisibility = useCallback((visible) => {
        setIsOpened((isOpened) => {
            const isVisible = visible !== null && visible !== void 0 ? visible : !isOpened;
            if (isVisible && labelRef.current) {
                const boundingClientRect = labelRef.current.getBoundingClientRect();
                setDimensions({
                    top: boundingClientRect.top +
                        boundingClientRect.height +
                        Spacing.Size.XXSmall,
                    left: boundingClientRect.left,
                    width: boundingClientRect.width,
                });
            }
            return visible !== null && visible !== void 0 ? visible : !isOpened;
        });
    }, []);
    const onChangeHandler = useCallback((selectedValue, selectedIndex) => {
        setSelected((selectedState) => {
            toggleVisibility(false);
            if (selectedValue === selectedState.value)
                return selectedState;
            onChange === null || onChange === void 0 ? void 0 : onChange(selectedValue);
            return Object.assign(Object.assign({}, options[selectedIndex]), { isSelected: true });
        });
    }, [onChange, options, toggleVisibility]);
    return (_jsxs(StyledContainer, { ref: containerRef, children: [label && (_jsx(StyledLabel, { htmlFor: id, children: _jsx(Text, { size: theme.Form.Input.Size, showTooltip: true, children: label }) })), _jsxs(StyledLabelContainer, { onClick: () => toggleVisibility(), ref: labelRef, isOpened: isOpened, children: [_jsx(Text, { size: 'Body', children: selected.label }), _jsx(StyledIconWrapper, { children: _jsx(Icon, { name: "chevron---20", angle: isOpened ? 180 : 0, color: theme.Color.Neutrals.Dark }) })] }), _jsx(Dropdown, { options: options, dimensions: dimensions, opened: isOpened, onSelect: onChangeHandler })] }));
}
//# sourceMappingURL=Select.js.map